module.exports = __webpack_public_path__ + "static/img/30013 (4).fef3f45.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30013 (4).webp
// module id = ZjEY
// module chunks = 14